import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Applique Nunito globalement */
  @font-face {
    font-family: 'DINRound';
    src: url('/assets/fonts/DINRound.otf') format('truetype');
  }

  body {
    font-family: 'Nunito', sans-serif; /* Utilisation de Nunito par défaut */
    margin: 0;
    padding: 0;
  }

  /* Applique Pally uniquement aux éléments spécifiés par une classe CSS ou un id */
  @font-face {
    font-family: 'Pally';
    src: url('/assets/fonts/pally.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  /* Par exemple, appliquer Pally à une classe spécifique */
  .pally-font {
    font-family: 'Pally', sans-serif;
  }

  /* Ou à un id spécifique */
  #pally-text {
    font-family: 'Pally', sans-serif;
  }
`;

export default GlobalStyle;
